import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import { useTheme } from './hooks/useTheme';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import ActualitesPage from './pages/ActualitesPage';
import ActualiteDetailPage from './pages/ActualiteDetailPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CGUPage from './pages/CGUPage';
import PolitiqueConfidentialitePage from './pages/PolitiqueConfidentialitePage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardPage from './pages/client/DashboardPage';
import ProfilePage from './pages/client/ProfilePage';
import SubscriptionsPage from './pages/client/SubscriptionsPage';
import SubscriptionDetailPage from './pages/client/SubscriptionDetailPage';
import EcheanciersPage from './pages/client/EcheanciersPage';
import PaymentsPage from './pages/client/PaymentsPage';
import NotificationsPage from './pages/client/NotificationsPage';
import DocumentsPage from './pages/client/DocumentsPage';
import DevisRequestsPage from './pages/client/DevisRequestsPage';
import ContactPersonsPage from './pages/client/ContactPersonsPage';
import ExtendedProfilePage from './pages/client/ExtendedProfilePage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PublicRoute from './components/auth/PublicRoute';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  useTheme(); // Appliquer le thème personnalisé
  
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-grow">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:id" element={<ProjectDetailPage />} />
              <Route path="/news" element={<ActualitesPage />} />
              <Route path="/news/:slug" element={<ActualiteDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/cgu" element={<CGUPage />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
              
              {/* Auth Routes - Redirigent vers dashboard si déjà connecté */}
              <Route path="/login" element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              } />
              <Route path="/register" element={
                <PublicRoute>
                  <RegisterPage />
                </PublicRoute>
              } />
              
              {/* Protected Client Routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } />
              <Route path="/subscriptions" element={
                <ProtectedRoute>
                  <SubscriptionsPage />
                </ProtectedRoute>
              } />
              <Route path="/subscriptions/:id" element={
                <ProtectedRoute>
                  <SubscriptionDetailPage />
                </ProtectedRoute>
              } />
              <Route path="/echeanciers" element={
                <ProtectedRoute>
                  <EcheanciersPage />
                </ProtectedRoute>
              } />
              <Route path="/payments" element={
                <ProtectedRoute>
                  <PaymentsPage />
                </ProtectedRoute>
              } />
              <Route path="/notifications" element={
                <ProtectedRoute>
                  <NotificationsPage />
                </ProtectedRoute>
              } />
              <Route path="/documents" element={
                <ProtectedRoute>
                  <DocumentsPage />
                </ProtectedRoute>
              } />
              <Route path="/devis-requests" element={
                <ProtectedRoute>
                  <DevisRequestsPage />
                </ProtectedRoute>
              } />
              <Route path="/contact-persons" element={
                <ProtectedRoute>
                  <ContactPersonsPage />
                </ProtectedRoute>
              } />
              <Route path="/extended-profile" element={
                <ProtectedRoute>
                  <ExtendedProfilePage />
                </ProtectedRoute>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Router>
    </AuthProvider>
  );
}

export default App;